import React, { PureComponent, Fragment } from 'react'
import styled from 'styled-components'
import { Link, withRouter } from 'react-router-dom'
import MobileMenu from './MobileMenu'

const HeaderOuter = styled.nav`
  width: 100%;
  position: sticky;
  top: 0px;
  background: ${props => (props.changeColor ? props.changeColor : '#fff')};
  z-index: 99;
  box-shadow: ${props => props.show && '0px 1px 3px 1px rgba(155, 155, 155, 0.6)'};
  ${props =>
    props.changeColor &&
    `
  
    &>div>div:last-child> a:hover{
      color: #fff;
    }
    &>div>div:last-child>div:hover{
      color: #fff;
    }
  `};
`
const HeaderWrapper = styled.div`
  display: flex;
  height: 70px;
  max-width: 1366px;
  padding: 0 80px;
  margin: 0 auto;
  @media (max-width: 992px) {
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    height: 50px;
  }
  @media (max-width: 640px) {
    padding: 16px 10px;
  }
`
const ImageWrapper = styled.span`
  display: flex;
  align-items: center;
`
const LogoLink = styled(Link)`
  cursor: pointer;
  padding: 30px 15px 15px 0px;
  & img {
    width: 65px;
    height: 20px;
  }

  @media (max-width: 992px) {
    padding: 18px 15px 15px 0px;
  }
`

const HeaderContentWrapper = styled.div`
  ${props =>
    props.type === 'product' &&
    `
  & > a:hover{
    color: #fff !important;
  }
`} @media (max-width: 992px) {
    display: none;
  }
  display: flex;
  align-items: center;
  padding-left: 85px;
  & > a {
    color: #999999;
  }
  @media (min-width: 993px) {
    & + div {
      display: none;
    }
  }
`

const MenuItems = styled(Link)`
  padding: 28px 15px 17px;
  line-height: 1.64;
  letter-spacing: 1.4px;
  position: relative;
  text-transform: uppercase;
  transition: 0.4s linear;
  :hover {
    color: #333333;
  }
  ${props =>
    props.active === 1 &&
    `
    color: #333333 !important;
    &:after {
      content: '';
      width: 20px;
      height: 2px;
      position: absolute;
      left: calc(60% - 20px);
      background-color: #333333;
      bottom: 15px;
      border-radius: 0px;
    }
    `};
`

const ProductItems = styled(Link)`
  line-height: 1.64;
  letter-spacing: 1.4px;
  position: relative;
  text-transform: uppercase;
  transition: 0.4s linear;
  :hover {
    color: #333333;
  }
`
const ProductsContainer = styled.div`
  padding: 28px 15px 17px;
  line-height: 1.64;
  letter-spacing: 1.4px;
  position: relative;
  text-transform: uppercase;
  cursor: pointer;
  position: relative;
  color: #999999;
  &:hover {
    color: #333333;
    & > div {
      visibility: visible;
      opacity: 1;
      width: 260px;
    }
  }
  ${props =>
    props.type === 'product' &&
    `
    &:hover{
      color: #fff;
    }
  `};
`
const ProductsWrapper = styled.div`
  position: absolute;
  padding: 0;
  width: 260px;
  border-radius: 0 0 2px 2px;
  box-shadow: 0 10px 35px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  left: 0;
  visibility: hidden;
  transition: opacity 0.4s linear;
  padding-top: 16px;
  opacity: 0;
  a:first-child {
    border-top: 2px solid #333333;
  }
  * & > a {
    background-color: #ffffff;
    padding: 12px 15px;
    &:hover {
      background: rgb(250, 251, 252);
    }
  }
`
class Header extends PureComponent {
  state = {
    show: false,
    showDropdown: false
  }
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }
  handleScroll = () => {
    if (window.pageYOffset >= 50) {
      this.setState({
        show: true
      })
    } else {
      this.setState({
        show: false
      })
    }
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }
  render() {
    const {
      location: { pathname }
    } = this.props
    return (
      <Fragment>
        <HeaderOuter
          changeColor={(pathname === '/extract' || pathname === '/trckr' || pathname === '/books') && '#333333'}
          show={this.state.show}>
          <HeaderWrapper>
            <ImageWrapper>
              <LogoLink to={{ pathname: '/' }}>
                <img src={require('../static/brand.svg')} alt="8OM" />
              </LogoLink>
            </ImageWrapper>
            <HeaderContentWrapper type={this.props.type}>
              <MenuItems active={pathname === '/' ? 1 : 0} to="/">
                home
              </MenuItems>
              <MenuItems active={pathname === '/about' ? 1 : 0} to="/about">
                about
              </MenuItems>
              <ProductsContainer type={this.props.type}>
                <Link active={pathname === '/services' ? 1 : 0} to="/services">
                  services
                </Link>
                <ProductsWrapper showDropdown={this.state.showDropdown}>
                  <ProductItems
                    active={pathname === '/services/web-development' ? 1 : 0}
                    to="/services/web-development">
                    Web Development
                  </ProductItems>
                  <ProductItems
                    active={pathname === '/services/app-development' ? 1 : 0}
                    to="/services/app-development">
                    App Development
                  </ProductItems>
                  <ProductItems
                    active={pathname === '/services/digital-marketing' ? 1 : 0}
                    to="/services/digital-marketing">
                    Digital Marketing
                  </ProductItems>
                  <ProductItems
                    active={pathname === '/experiential-marketing' ? 1 : 0}
                    to="/services/experiential-marketing">
                    Experiential Marketing
                  </ProductItems>
                  <ProductItems active={pathname === '/web-crawling' ? 1 : 0} to="/services/web-crawling">
                    Web Crawling
                  </ProductItems>
                  <ProductItems active={pathname === '/ux-ui' ? 1 : 0} to="/services/ux-ui">
                    Ux/Ui
                  </ProductItems>
                </ProductsWrapper>
              </ProductsContainer>
              <MenuItems active={pathname === '/clients' ? 1 : 0} to="/clients">
                clients
              </MenuItems>
              <ProductsContainer type={this.props.type}>
                Products
                <ProductsWrapper showDropdown={this.state.showDropdown}>
                  <ProductItems active={pathname === '/trckr' ? 1 : 0} to="/trckr">
                    trckr
                  </ProductItems>
                  <ProductItems active={pathname === '/extract' ? 1 : 0} to="/extract">
                    extract
                  </ProductItems>
                  <ProductItems active={pathname === '/books' ? 1 : 0} to="/books">
                    books
                  </ProductItems>
                </ProductsWrapper>
              </ProductsContainer>
              <MenuItems active={pathname === '/contact' ? 1 : 0} to="/contact">
                contact
              </MenuItems>
            </HeaderContentWrapper>
            <MobileMenu type={this.props.type} />
          </HeaderWrapper>
        </HeaderOuter>
      </Fragment>
    )
  }
}
export default withRouter(Header)



// WEBPACK FOOTER //
// ./src/components/Header.js